import apiClient from './client';

export interface SatIntakeRequest {
  fullName: string;
  email: string;
  phone?: string;
  gradeLevel?: string;
  targetTestDate?: string;
  referralCode?: string;
  /** Honeypot — must stay empty; bots that fill it are silently dropped server-side. */
  website?: string;
}

export interface SatIntakeSubmission {
  id: string;
  fullName: string;
  email: string;
  phone: string | null;
  gradeLevel: string | null;
  targetTestDate: string | null;
  referralCode: string | null;
  createdAt: string;
}

export const marketingApi = {
  submitSatIntake: async (request: SatIntakeRequest): Promise<void> => {
    try {
      await apiClient.post('/marketing/sat-intake', request);
    } catch (error) {
      throw new Error('Failed to submit. Please try again.');
    }
  },

  listSatIntakeSubmissions: async (): Promise<SatIntakeSubmission[]> => {
    try {
      const response = await apiClient.get<SatIntakeSubmission[]>('/admin/sat-intake');
      return response.data;
    } catch (error) {
      throw new Error('Failed to load signups. Please try again.');
    }
  },
};
